import { makeStyles } from "@mui/styles";

import type { Theme } from "src/theme";

export const useDashboardLayoutStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,

        width: "100vw",
        minWidth: `${theme.constants.minScreenWidth}px`,

        minHeight: "100vh",

        paddingTop: theme.constants.headerHeight,

        [theme.breakpoints.down(1280)]: {
            minHeight: `calc(100vh - 15px)`,
        },
    },

    content: {
        height: `calc(100vh - ${theme.constants.headerHeight}px)`,
        overflowY: "auto",

        [theme.breakpoints.down(1280)]: {
            height: `calc(100vh - ${theme.constants.headerHeight}px - 15px)`,
        },
    },
}));
